import React from 'react'
import {Header, List} from 'semantic-ui-react'

const ProxyFromRealServices = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Proxy From Real Services</Header>
      <p>
        In some cases, it makes sense to sit a mock in front of a real service so you can take ownership
        of responses.
      </p>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to the service/version/environment/resource you wish to work with.</List.Item>
        <List.Item>2. Click the "Add Response" button</List.Item>
        <List.Item>3. Click on the "Settings" tab and then on the "Proxy" button below</List.Item>
        <List.Item>4. Enter the URL you want to point to in the "Send Request To URL" field</List.Item>
        <List.Item>
          5. Toggle the "Include Resource Path/Query In Request" field on/off
          <List.List>
            <List.Item>
              "on" - Service Mocks will append the parent resource path to the URL you supply
            </List.Item>
            <List.Item>
              "off" - Service Mocks will use the URL you provide w/ no alteration.
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item>6. Review the URL in the "Example Proxy Request"</List.Item>
        <List.Item>7. Send a request to confirm the response proxies from a real service</List.Item>
      </List>
    </div>
  )
}

export {ProxyFromRealServices}

export default ProxyFromRealServices